import React, { useContext, useEffect } from "react";
import Select from "react-select";
import themeContext from "../context/theme/ThemeContext";
import { BORDER } from "../constants/Constants";

const CustomSelect = (props) => {
    const zIndex = props.zIndex != null && props.zIndex != undefined ? props.zIndex : 1000;
    const { getThemeColor } = useContext(themeContext);
    const isClearable = props.isClearable != null && props.isClearable != undefined ? props.isClearable : false;

    useEffect(() => {
        const elements = document.querySelectorAll('.react-select-modal__input-container');
        //console.log("--- Elements ----",elements)
        if (elements.length > 0) {
          elements.forEach(element => {
            element.style.color = getThemeColor("primary-color");
          });
        }
      }, [document.querySelectorAll('.react-select-modal__input-container')]);

    useEffect(() => {
      const elements = document.querySelectorAll('.react-select-modal__single-value');
      //console.log("--- Elements ----",elements)
      if (elements.length > 0) {
        elements.forEach(element => {
          element.style.color = getThemeColor("primary-color");
        });
      }
    }, [document.querySelectorAll('.react-select-modal__single-value')]);

  return (
    <Select
      classNamePrefix="react-select-modal"
      options={props.options}
      // defaultValue={ props.filterObj.minimalClientId }
      defaultValue={props.defaultValue}
      value={props.value}
      label={props.label}
      placeholder={props.placeholder}
      styles={{
        container: (baseStyles) => ({
          ...baseStyles,
          lineHeight: "30px",
          zIndex: zIndex,
          margin: "0 8px",
          color: getThemeColor("primary-color"),
        }),
        control: (baseStyles) => ({
          ...baseStyles,
          width: "100% !important",
          color: getThemeColor("primary-color"),
          border: props.errorState?.state?.error
            ? "1px solid rgb(164, 38, 44) !important"
            : getThemeColor("border"),
          backgroundColor: getThemeColor("action-details-background"),
          ".react-select__input-container": {
            color: getThemeColor("primary-color")
        }
        }),
        menu: (baseStyles, state) => ({
          ...baseStyles,
          width: "100% !important",
          maxHeight: props.maxHeight != null && props.maxHeight != undefined ? "100px" : "unset",
          overflowY: "auto", 
          backgroundColor: state.isFocused ? getThemeColor("popup-hover") : getThemeColor("action-details-background"),
          "&:hover": {
            backgroundColor: `${getThemeColor("popup-hover")} !important`,
          },
          boxShadow: "5px 0 8px rgba(0, 0, 0, 0.2), -5px 0 8px rgba(0, 0, 0, 0.2), 0 5px 8px rgba(0, 0, 0, 0.2)"
        }),
        menuList: (baseStyles, state) => ({
          ...baseStyles,
          maxHeight: props.maxHeight != null && props.maxHeight != undefined ? "100px" : "unset",
          backgroundColor: state.isFocused ? getThemeColor("popup-hover") : getThemeColor("action-details-background"),
          "&:hover": {
            backgroundColor: `${getThemeColor("popup-hover")} !important`,
          },
        }),
        option: (provided, state) => ({
          ...provided,
          fontSize: "14px",
          lineHeight: "18px",
          color: getThemeColor("primary-color"),
          backgroundColor: state.isFocused ? getThemeColor("popup-hover") : getThemeColor("action-details-background"),
          "&:hover": {
            backgroundColor: `${getThemeColor("popup-hover")} !important`,
          },
        }),
      }}
      onChange={props.onChange}
      isClearable={isClearable}
    />
  );
};

export default CustomSelect;

export const stylesForCustomSelect = (getThemeColor) =>  {
  return {
    container: (baseStyles) => ({
      ...baseStyles,
      zIndex: 1000,
      margin: "0 8px",
      color: getThemeColor("primary-color"),
    }),
    control: (baseStyles) => ({
      ...baseStyles,
      color: getThemeColor("primary-color"),
      backgroundColor: getThemeColor("action-details-background"),
    }),
    menu: (baseStyles, state) => ({
      ...baseStyles,
      backgroundColor: state.isFocused ? getThemeColor("popup-hover") : getThemeColor("action-details-background"),
      "&:hover": {
        backgroundColor: `${getThemeColor("popup-hover")} !important`,
      },
    }),
    menuList: (baseStyles, state) => ({
      ...baseStyles,
      backgroundColor: state.isFocused ? getThemeColor("popup-hover") : getThemeColor("action-details-background"),
      "&:hover": {
        backgroundColor: `${getThemeColor("popup-hover")} !important`,
      },
    }),
    option: (provided, state) => ({
      ...provided,
      color: getThemeColor("primary-color"),
      backgroundColor: state.isFocused ? getThemeColor("popup-hover") : getThemeColor("action-details-background"),
      "&:hover": {
        backgroundColor: `${getThemeColor("popup-hover")} !important`,
      },
    })
  };
}



export const constantStyleForSelect = (getThemeColor,error) => {
  const errorPresent = error == null || error == undefined ? false : true;
  return {
    control: (baseStyles, state) => ({
      ...baseStyles,
      width: "100% !important",
      color: getThemeColor("primary-color"),
      backgroundColor: getThemeColor("action-details-background"),
      border: errorPresent? "1px solid rgb(164, 38, 44) !important": getThemeColor("border"),
    }),
    menu: (baseStyles,state) => ({
      ...baseStyles,
      width: "100% !important",
      backgroundColor: state.isFocused ? getThemeColor("popup-hover") : getThemeColor("action-details-background"),
      '&:hover': {
        backgroundColor: `${getThemeColor("popup-hover")} !important`,
      },
    }),
    menuList: (baseStyles, state) => ({
      ...baseStyles,
      backgroundColor: state.isFocused ? getThemeColor("popup-hover") : getThemeColor("action-details-background"),
      '&:hover': {
        backgroundColor: `${getThemeColor("popup-hover")} !important`,
      },
    }),
    option: (provided, state) => ({
      ...provided,
      color: getThemeColor("primary-color"),
      backgroundColor: state.isFocused ? getThemeColor("popup-hover") : getThemeColor("action-details-background"),
      '&:hover': {
        backgroundColor: `${getThemeColor("popup-hover")} !important`,
      },
    }),
}
}
